/* ==========================================================================
   AHIHQ Motors theme — CORE (the Shopify version of the mockup's app.js).
   Provides window.M with the SAME API the section scripts were written against
   (see Website/mockup-v2/CONTRACT.md), but backed by live store data:
     - cars come from the JSON stock feed (/collections/<h>?view=feed), and on a
       car page the car's own full record is inlined by Liquid (window.AHM.car);
     - there is no hash router: each Shopify template declares its view
       (<body data-view="home|stock|car|sold|find|contact|page">);
     - links are real URLs (M.urls, M.stockUrl, car.url);
     - WhatsApp number, partner note and need lists come from theme settings.
   Section scripts register with M.view(name, {init, render}) exactly as before.
   ========================================================================== */
(function () {
  'use strict';
  var A = window.AHM || {};
  var MARQUES = window.MARQUES || {};
  var ALL = [];
  var BY_REF = {};
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var URLS = Object.assign({ home: '/', stock: '/collections/all', saved: '/pages/saved', find: '/pages/find-me-a-car', contact: '/pages/contact' }, A.urls || {});
  var ORIGIN = A.origin || location.origin;
  var NETWORK = A.network || {};
  var PARTNER = A.partnerNote !== false;

  /* ---------- storage (always wrapped: may be blocked) ---------- */
  function sget(k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  function sset(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  function ssget(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssset(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* quota: ignore */ } }

  /* ---------- formatting ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(n) { n = Math.round(Number(n) || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function km(n) { return fmt(n) + ' km'; }
  function date(iso, withYear) {
    if (!iso) return ''; var p = String(iso).slice(0, 10).split('-'); if (p.length < 3) return iso;
    return parseInt(p[2], 10) + ' ' + MONTHS[parseInt(p[1], 10) - 1] + (withYear ? ' ' + p[0] : '');
  }
  function todayYMD() { var d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shortRef(car) { var r = String((car && car.ref) || car || ''); var i = r.indexOf('-'); return i > -1 ? r.slice(i + 1) : r; }

  /* ---------- icons ---------- */
  var P = {
    heart: '<path d="M12 20.3s-7.5-4.6-7.5-10.1A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.5-7.5 10.1-7.5 10.1z"/>',
    search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    'arrow-right': '<path d="M5 12h14M13 6l6 6-6 6"/>',
    'arrow-left': '<path d="M19 12H5M11 6l-6 6 6 6"/>',
    'chevron-right': '<path d="M9 5l7 7-7 7"/>',
    'chevron-left': '<path d="M15 5l-7 7 7 7"/>',
    'chevron-down': '<path d="M5 9l7 7 7-7"/>',
    pin: '<path d="M12 21s-6.5-6.1-6.5-11A6.5 6.5 0 0 1 18.5 10c0 4.9-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
    calendar: '<rect x="4" y="5.5" width="16" height="14.5" rx="2"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4"/>',
    share: '<path d="M12 3.5v12M7.5 8L12 3.5 16.5 8"/><path d="M5 12.5v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/>',
    expand: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    phone: '<path d="M6.5 3.5h3l1.5 4.5-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4.5 1.5v3a2 2 0 0 1-2 2A16.5 16.5 0 0 1 4.5 5.5a2 2 0 0 1 2-2z"/>',
    mail: '<rect x="3.5" y="5.5" width="17" height="13" rx="2"/><path d="M4 7l8 6 8-6"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    filter: '<path d="M4 6h16M7 12h10M10 18h4"/>',
    sliders: '<path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/>',
    grid: '<rect x="4" y="4" width="7" height="7" rx="1"/><rect x="13" y="4" width="7" height="7" rx="1"/><rect x="4" y="13" width="7" height="7" rx="1"/><rect x="13" y="13" width="7" height="7" rx="1"/>',
    list: '<path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01"/>',
    gauge: '<path d="M4.5 16a8 8 0 1 1 15 0"/><path d="M12 13l3.5-4"/>',
    gear: '<circle cx="12" cy="12" r="3"/><path d="M12 3.5v2.5M12 18v2.5M3.5 12H6M18 12h2.5M6 6l1.8 1.8M16.2 16.2L18 18M6 18l1.8-1.8M16.2 7.8L18 6"/>',
    fuel: '<path d="M5 20V5.5A1.5 1.5 0 0 1 6.5 4h6A1.5 1.5 0 0 1 14 5.5V20M4 20h11M5 10h9"/><path d="M14 8l3 2.5V17a1.5 1.5 0 0 0 3 0V9l-2.5-2.5"/>',
    road: '<path d="M8 3.5L4.5 20.5M16 3.5l3.5 17M12 5v2.5M12 11v2.5M12 17v2.5"/>',
    ship: '<path d="M3.5 15.5l1.8 4h13.4l1.8-4-8.5-3z"/><path d="M6 13.8V8.5h12v5.3M12 8.5V4.5"/>',
    car: '<path d="M4 16.5V13l2-5h12l2 5v3.5"/><path d="M3.5 13h17"/><circle cx="7.5" cy="16.5" r="1.8"/><circle cx="16.5" cy="16.5" r="1.8"/>',
    key: '<circle cx="8" cy="15" r="4"/><path d="M11 12l8.5-8.5M16 7l2.5 2.5M14 9l2 2"/>',
    doc: '<path d="M7 3.5h7l4 4v13H7z"/><path d="M14 3.5v4h4M9.5 12h6M9.5 15.5h6"/>',
    handshake: '<path d="M3 11l4-4 4 2 3-2 7 5"/><path d="M7 7v0M3 11l6 6a1.5 1.5 0 0 0 2 0l1-1M21 12l-5 5a1.5 1.5 0 0 1-2 0l-2-2"/>',
    eye: '<path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.8"/>',
    info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5M12 8h.01"/>',
    camera: '<path d="M4 8h3l1.5-2.5h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    external: '<path d="M14 4.5h5.5V10M19.5 4.5L11 13M17 14v5.5H4.5V7H10"/>',
    compass: '<circle cx="12" cy="12" r="8.5"/><path d="M15.5 8.5l-2 5-5 2 2-5z"/>'
  };
  var WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z';
  function icon(name, opts) {
    opts = opts || {}; var s = opts.size || 20; var cls = opts.cls ? ' class="' + opts.cls + '"' : '';
    if (name === 'whatsapp') return '<svg' + cls + ' width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + WA_PATH + '"/></svg>';
    if (name === 'heart-fill') return '<svg' + cls + ' width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">' + P.heart + '</svg>';
    return '<svg' + cls + ' width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (opts.stroke || 1.5) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (P[name] || '') + '</svg>';
  }

  var NON_ROAD = /tractor|truck|bus|motorbike|motorcycle/i;

  /* ---------- the car record (feed / inline) → the shape the sections expect ---------- */
  var TODAY = todayYMD();
  function normalise(c) {
    if (!c || c._n) return c;
    c._n = 1;
    c.ref = String(c.ref || '');
    c.year = Number(c.year) || c.year;
    c.km = c.km == null || c.km === '' ? null : Number(c.km);
    c.status = c.status === 'way' || c.status === 'on_the_way' ? 'way' : 'in';
    c.title = c.title || [c.year, c.make, c.model].filter(Boolean).join(' ');
    c.published = true;
    c.features = c.features || [];
    c.photos = (c.photos || []).filter(function (p) { return p && p.m; });
    c.cover = c.cover || 0;
    c.eta = c.eta || '';
    c.etaFuture = !!(c.eta && String(c.eta).slice(0, 10) > TODAY);
    return c;
  }
  function addCars(list) {
    (list || []).forEach(function (c) {
      normalise(c);
      var prev = BY_REF[c.ref];
      if (prev) { Object.keys(c).forEach(function (k) { if (prev[k] == null || (Array.isArray(prev[k]) && !prev[k].length)) prev[k] = c[k]; }); return; }
      BY_REF[c.ref] = c; ALL.push(c);
    });
  }
  function currentCars() { return ALL.slice(); }
  function byRef(ref) { return BY_REF[ref] || null; }
  function counts(cars) {
    cars = cars || currentCars();
    var o = { total: cars.length, in: 0, way: 0, nairobi: 0, mombasa: 0, inJapan: 0, inTransit: 0, atPort: 0 };
    cars.forEach(function (c) {
      if (c.status === 'in') { o.in++; if (c.loc === 'Nairobi') o.nairobi++; if (c.loc === 'Mombasa') o.mombasa++; }
      else { o.way++; if (/Japan/.test(c.stage)) o.inJapan++; else if (/transit/i.test(c.stage)) o.inTransit++; else if (/port/i.test(c.stage)) o.atPort++; }
    });
    return o;
  }
  function networkSummary() {
    var n = NETWORK;
    return {
      here: n.inStock || 0, nairobi: n.inStockNairobi || 0, mombasa: n.inStockMombasa || 0,
      way: n.onTheWay || 0, inJapan: n.inJapan || 0, inTransit: n.inTransit || 0, atPort: n.atPort || 0,
      unknown: n.unknown || 0, total: n.total || 0, date: date(n.packDate, true), dateShort: date(n.packDate),
      held: PARTNER ? 'partner showrooms' : 'showrooms in our network'
    };
  }

  /* true only when the partner network holds more cars than are published here (never claim "more" otherwise) */
  function netMore() {
    var n = NETWORK || {}, net = (n.inStock || 0) + (n.onTheWay || 0);
    var pub = typeof A.publishedTotal === 'number' ? A.publishedTotal : ALL.length;
    return net > pub;
  }

  /* ---------- availability ---------- */
  function avail(car) {
    if (car.status === 'in') {
      var where = car.loc ? car.loc + (PARTNER ? ' partner showroom' : '') : '';
      return { cls: 'in', dot: 'dot', word: 'Here now', where: where, text: 'Here now' + (where ? ' · ' + where : '') };
    }
    var st = car.stage || '';
    var detail = /Japan/.test(st) ? 'In Japan / shipping' : /transit/i.test(st) ? 'In transit' : /port/i.test(st) ? 'At Mombasa port' : (st || 'On the way');
    var due = (car.eta && car.etaFuture) ? 'due ' + date(car.eta) : '';
    return { cls: 'way', dot: 'dot dot--way', word: 'Arriving', where: detail + (due ? ' · ' + due : ''), due: due, text: 'Arriving · ' + detail + (due ? ' · ' + due : '') };
  }
  function availHTML(car) { var a = avail(car); return '<span class="avail"><span class="' + a.dot + '" aria-hidden="true"></span><span><b>' + esc(a.word) + '</b>' + (a.where ? ' · ' + esc(a.where) : '') + '</span></span>'; }
  function kmKnown(car) { return car.km != null && !(NON_ROAD.test(car.body || '') && !car.km); }
  function specParts(car, opts) {
    opts = opts || {};
    var p = [kmKnown(car) ? km(car.km) : '', car.trans, car.fuel, car.engine, car.drive].filter(Boolean);
    return opts.max ? p.slice(0, opts.max) : p;
  }

  /* ---------- WhatsApp: ONE theme setting (settings.whatsapp) ---------- */
  var WA = String(A.wa || '').replace(/[^\d]/g, '');
  function carHandle(car) { return (car.url || '').split('/products/')[1] || ''; }
  function carUrl(car) { return ORIGIN + (car.url || ''); }
  function carMessage(car, question) {
    return 'Hi AHIHQ Motors, I am asking about the ' + car.title + ' (Ref ' + car.ref + ')' + (question ? ': ' + question : '.') + ' ' + carUrl(car);
  }
  function waLink(text) {
    if (!WA) return URLS.contact; // no number configured: send people to the contact page, never a dead wa.me link
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text || '');
  }
  function waAttrs(text) {
    var h = waLink(text);
    return WA ? 'href="' + esc(h) + '" target="_blank" rel="noopener"' : 'href="' + esc(h) + '" data-wa-missing="1"';
  }
  function waApply(a, text) {
    var h = waLink(text); a.setAttribute('href', h);
    if (!WA) { a.setAttribute('data-wa-missing', '1'); a.removeAttribute('target'); a.removeAttribute('rel'); }
    else { a.removeAttribute('data-wa-missing'); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
    return a;
  }
  var QUESTIONS = ['Is it still available?', 'What is your best price?', 'Can I book a viewing?', 'Do you offer finance?', 'Can I trade in my car?'];

  /* ---------- saved cars (localStorage 'ahm-saved' — same key as theme v1) ---------- */
  var saved = new Set((sget('ahm-saved', []) || []).map(String));
  function persistSaved() { sset('ahm-saved', Array.from(saved)); }
  function isSaved(ref) { return saved.has(ref); }
  function syncSaved() {
    var n = saved.size;
    document.querySelectorAll('[data-saved-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    document.querySelectorAll('[data-save]').forEach(function (b) {
      var on = saved.has(b.getAttribute('data-save'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var ic = b.querySelector('[data-heart]'); if (ic) ic.innerHTML = icon(on ? 'heart-fill' : 'heart');
    });
    document.querySelectorAll('[data-saved-label]').forEach(function (el) { el.textContent = n ? n + ' saved' : 'Saved'; });
  }
  function toggleSaved(ref) {
    var on;
    if (saved.has(ref)) { saved.delete(ref); on = false; } else { saved.add(ref); on = true; }
    persistSaved(); syncSaved();
    var car = byRef(ref);
    toast(on ? 'Saved ' + (car ? car.title : ref) + '.' : 'Removed ' + (car ? car.title : ref) + ' from saved.');
    document.dispatchEvent(new CustomEvent('mock:saved', { detail: { ref: ref, saved: on, count: saved.size } }));
    return on;
  }

  /* ---------- images (Shopify CDN: m = 720w, l = 1600w; 1100w derived from m) ---------- */
  function photoOf(car, i) { if (!car || !car.photos || !car.photos.length) return null; return car.photos[i == null ? (car.cover || 0) : i] || car.photos[0]; }
  function img(photo, o) {
    o = o || {}; if (!photo) return '';
    var w = photo.w || 1600, h0 = photo.h || 1200;
    var mw = Math.min(720, w);
    // 720 / 1100 / 1600 — the same widths the Liquid renders, so a server-rendered photo is reused, not fetched twice
    var mid = (w > 1100 && photo.l && /width=720/.test(photo.m)) ? photo.m.replace('width=720', 'width=1100') : '';
    var srcset = photo.m + ' ' + mw + 'w' + (mid ? ', ' + mid + ' 1100w' : '') + (w > mw && photo.l ? ', ' + photo.l + ' ' + Math.min(w, 1600) + 'w' : '');
    var h = Math.round(h0 * (mw / w));
    return '<img src="' + esc(photo.m) + '" srcset="' + esc(srcset) + '" sizes="' + esc(o.sizes || '(max-width: 600px) 100vw, 360px') + '" width="' + mw + '" height="' + h + '" alt="' + esc(o.alt != null ? o.alt : (photo.alt || '')) + '"' +
      (o.eager ? ' loading="eager" fetchpriority="' + (o.priority || 'high') + '"' : ' loading="lazy"') + ' decoding="async"' + (o.cls ? ' class="' + o.cls + '"' : '') + '>';
  }
  var MARK_TEXT = {};

  /* ---------- the vehicle card ("plinth") — identical markup to the mockup ---------- */
  function card(car, opts) {
    opts = opts || {};
    var v = opts.variant || 'default';
    var ph = photoOf(car);
    var a = avail(car);
    var sizes = opts.sizes || (v === 'feature' ? '(max-width: 600px) 100vw, 800px' : v === 'compact' ? '(max-width: 600px) 100vw, 280px' : '(max-width: 600px) 100vw, 400px');
    var more = [car.colour, car.body, car.cond].filter(Boolean).join(' · ');
    var el = document.createElement('article');
    el.className = 'vc vc--' + v + (opts.cls ? ' ' + opts.cls : '');
    el.setAttribute('data-ref', car.ref);
    el.setAttribute('data-status', car.status);
    var saveOn = isSaved(car.ref);
    var titleId = 'vc-t-' + String(car.ref).replace(/[^\w-]/g, '') + '-' + (card._n = (card._n || 0) + 1);
    el.setAttribute('aria-labelledby', titleId);
    var H = opts.headingLevel || 'h3';
    el.innerHTML =
      '<div class="vc-inner">' +
        '<div class="vc-media">' + (ph ? img(ph, { sizes: sizes, eager: !!opts.eager, alt: ph.alt || car.title }) : '<span class="vc-nophoto">Photos coming</span>') +
          (car.status === 'way' ? '<span class="vc-tag">' + esc(a.word) + '</span>' : '') +
        '</div>' +
        '<div class="vc-body">' +
          '<p class="vc-avail">' + availHTML(car) + '</p>' +
          '<p class="vc-make">' + esc(car.make) + '</p>' +
          '<' + H + ' class="vc-title" id="' + titleId + '"><a href="' + esc(car.url) + '">' + esc(car.model) + ' <span class="vc-year">' + esc(car.year) + '</span></a></' + H + '>' +
          '<p class="vc-spec">' + specParts(car, { max: v === 'compact' ? 3 : 0 }).map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('') + '</p>' +
          (v !== 'compact' ? '<p class="vc-more" aria-hidden="true">' + esc(more) + '</p>' : '') +
          '<div class="vc-foot">' +
            '<div class="vc-meta"><span class="vc-ref">Ref ' + esc(shortRef(car)) + '</span><span class="vc-price">Price on request</span></div>' +
            '<div class="vc-actions">' +
              '<button type="button" class="icon-btn vc-save" data-save="' + esc(car.ref) + '" aria-pressed="' + saveOn + '" aria-label="Save ' + esc(car.title) + '"><span data-heart>' + icon(saveOn ? 'heart-fill' : 'heart') + '</span></button>' +
              (v !== 'compact' ? '<a class="vc-details" href="' + esc(car.url) + '" tabindex="-1" aria-hidden="true">Details <span class="arr">→</span></a>' : '') +
              '<a class="icon-btn vc-wa" ' + waAttrs(carMessage(car, 'Is it still available?')) + ' aria-label="Ask about the ' + esc(car.title) + ' on WhatsApp">' + icon('whatsapp') + '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    return el;
  }

  /* ---------- marques (logo data: assets/ahm-marques-data.js; overrides via theme blocks later) ---------- */
  function marque(make) { return MARQUES[String(make || '').toLowerCase()] || null; }
  function marqueSVG(make, o) {
    o = o || {}; var m = marque(make); if (!m) return '';
    return '<svg viewBox="' + m.viewBox + '" width="' + (o.size || 44) + '" height="' + (o.size || 44) + '" role="img" aria-label="' + esc(m.title) + '"' + (o.cls ? ' class="' + o.cls + '"' : '') + '><path d="' + m.path + '"/></svg>';
  }
  function makes(cars) {
    cars = cars || currentCars(); var map = {};
    cars.forEach(function (c) { if (!c.make) return; var k = c.make.toLowerCase(); (map[k] = map[k] || { make: c.make, key: k, count: 0, in: 0, way: 0, cars: [] }); map[k].count++; map[k][c.status]++; map[k].cars.push(c); });
    var bm = NETWORK.byMake || {};
    return Object.keys(map).map(function (k) { var o = map[k]; o.logo = marque(o.make); var n = bm[o.make] || {}; o.networkIn = n.in || 0; o.networkWay = n.way || 0; return o; })
      .sort(function (a, b) { return b.count - a.count || a.make.localeCompare(b.make); });
  }

  /* ---------- "shop by real life": hand-picked model lists from theme settings ---------- */
  var L = {};
  var LISTS = A.needs || {};
  Object.keys(LISTS).forEach(function (k) { L[k] = (LISTS[k] || []).map(function (s) { return String(s).trim(); }).filter(Boolean); });
  function inList(car, list) {
    if (!list || !list.length) return false;
    var full = (car.make + ' ' + car.model).toLowerCase();
    return list.some(function (e) { e = e.toLowerCase(); return full === e || full.indexOf(e + ' ') === 0 || String(car.make).toLowerCase() === e; });
  }
  var NEEDS = [
    { key: 'family', label: 'Family & school run', sub: 'Seven and eight seaters, sliding doors, room for the school bags.', light: '#E9B872', test: function (c) { return inList(c, L.family); } },
    { key: 'upcountry', label: 'Upcountry roads', sub: 'Proper 4x4s and high-riding SUVs for murram, rain and long drives.', light: '#C98A4B', test: function (c) { return inList(c, L.upcountry) && (c.drive === '4WD' || /pickup|double cab/i.test(c.body || '')); } },
    { key: 'hailing', label: 'Uber & Bolt', sub: 'Frugal, reliable cars that the ride-hailing apps accept.', light: '#F2C46B', test: function (c) { return inList(c, L.hailing); } },
    { key: 'exec', label: 'Executive', sub: 'Quiet saloons and SUVs for the office and the airport run.', light: '#9FB3D9', test: function (c) { return inList(c, L.exec); } },
    { key: 'lowkm', label: 'Low mileage', sub: 'Under 50,000 km on the clock.', light: '#B9D7C8', test: function (c) { return c.km != null && c.km < 50000 && !NON_ROAD.test(c.body || ''); } },
    { key: 'economy', label: 'Everyday economy', sub: 'Small, simple, cheap to run and easy to park in town.', light: '#E7DCC8', test: function (c) { return inList(c, L.economy); } },
    { key: 'hybrid', label: 'Hybrid & electric', sub: 'Petrol-hybrid and electric cars that go further per shilling.', light: '#6FD3A0', test: function (c) { return /hybrid|electric/i.test(c.fuel || ''); } },
    { key: 'luxury', label: 'Luxury & performance', sub: 'The flagship end: Land Cruiser, Defender, Porsche, Lexus.', light: '#F06A5E', test: function (c) { return inList(c, L.luxury); } }
  ];
  NEEDS.forEach(function (n) { n.lists = L[n.key] || null; });
  function need(key) { if (key === 'low') key = 'lowkm'; return NEEDS.filter(function (n) { return n.key === key; })[0] || null; }
  function needsOf(car) { return NEEDS.filter(function (n) { return n.test(car); }).map(function (n) { return n.key; }); }
  function carsForNeed(key, cars) { var n = need(key); cars = cars || currentCars(); return n ? cars.filter(n.test) : []; }

  /* ---------- route: the template declares the view; params come from the query string ---------- */
  function parseQuery(q) {
    var params = {};
    String(q || '').replace(/^\?/, '').split('&').forEach(function (kv) { if (!kv) return; var p = kv.split('='); try { params[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' ')); } catch (e) { } });
    return params;
  }
  var BODY = document.body;
  var route = {
    view: (BODY && BODY.getAttribute('data-view')) || 'page',
    ref: (A.car && A.car.ref) || (BODY && BODY.getAttribute('data-ref')) || null,
    params: Object.assign({}, A.preset || {}, parseQuery(location.search)),
    hash: location.hash
  };
  if (route.view === 'saved') { route.view = 'stock'; route.params.saved = '1'; }
  function stockUrl(p) {
    var base = (p && p.saved) ? URLS.saved : (route.view === 'stock' && !route.params.saved ? location.pathname : URLS.stock);
    var q = Object.keys(p || {}).filter(function (k) { return p[k] != null && p[k] !== '' && !(k === 'saved' && base === URLS.saved); })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]); }).join('&');
    return base + (q ? '?' + q : '');
  }
  /* go(url): same page → update the query in place and re-render (no reload); other page → navigate.
     Legacy hash targets from the mockup ('#stock?…', '#find', '#car-REF') are translated. */
  function toUrl(target) {
    target = String(target || '');
    if (target.charAt(0) !== '#') return target;
    var h = target.slice(1), q = '', i = h.indexOf('?'); if (i > -1) { q = h.slice(i + 1); h = h.slice(0, i); }
    var m;
    if (h === 'stock') { var p = parseQuery(q); return stockUrl(p); }
    if (h === 'find') return URLS.find + (q ? '?' + q : '');
    if (h === 'home' || h === '') return URLS.home;
    if ((m = h.match(/^car-(.+)$/))) { var c = byRef(m[1]); return c ? c.url : URLS.stock; }
    return target; // a plain in-page anchor
  }
  function go(target) {
    var url = toUrl(target);
    if (url.charAt(0) === '#') { var el = document.getElementById(url.slice(1)); if (el) el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' }); return; }
    var a = document.createElement('a'); a.href = url;
    var samePage = a.pathname === location.pathname || (route.params.saved && a.pathname === URLS.saved && location.pathname === URLS.saved);
    if (samePage && route.view === 'stock') {
      history.replaceState(null, '', a.pathname + a.search + a.hash);
      route = { view: route.view, ref: route.ref, params: Object.assign({}, A.preset || {}, parseQuery(a.search), location.pathname === URLS.saved ? { saved: '1' } : {}), hash: a.hash };
      renderAll();
      document.dispatchEvent(new CustomEvent('mock:route', { detail: ctx() }));
      return;
    }
    location.href = url;
  }
  function scroller() { return null; }
  function scrollTop() { window.scrollTo(0, 0); }

  /* ---------- view registry ---------- */
  var REG = {};
  function view(name, def) { REG[name] = def || {}; }
  function ctx() { return { cars: currentCars(), all: ALL.slice(), route: route, device: 'desktop', catalogue: 'live', partnerNote: PARTNER, whatsapp: WA, network: NETWORK }; }
  function slotEls(name) { return document.querySelectorAll('[data-slot="' + name + '"]'); }
  var inited = {};
  function initAll() {
    Object.keys(REG).forEach(function (n) {
      slotEls(n).forEach(function (el, i) {
        var key = n + ':' + i; if (inited[key]) return; inited[key] = 1;
        if (typeof REG[n].init === 'function') { try { REG[n].init(el, ctx()); } catch (e) { console.error('[ahm ' + n + '] init failed', e); } }
      });
    });
  }
  function renderAll() {
    Object.keys(REG).forEach(function (n) {
      slotEls(n).forEach(function (el) { if (typeof REG[n].render === 'function') { try { REG[n].render(el, ctx()); } catch (e) { console.error('[ahm ' + n + '] render failed', e); } } });
    });
    syncSaved();
  }

  /* ---------- data: the stock feed (all pages) + the inlined car (car page) ---------- */
  function loadFeed(url) {
    var key = 'ahm-feed2:' + url;
    var c = ssget(key);
    if (c && c.t && (Date.now() - c.t) < 10 * 60 * 1000 && c.cars) return Promise.resolve(c.cars);
    var get = function (p) { return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'page=' + p, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); };
    return get(1).then(function (first) {
      var rest = []; for (var p = 2; p <= (first.pages || 1); p++) rest.push(get(p));
      return Promise.all(rest).then(function (more) {
        var cars = first.cars.concat.apply(first.cars, more.map(function (m) { return m.cars; }));
        ssset(key, { t: Date.now(), cars: cars });
        return cars;
      });
    });
  }

  /* ---------- layers: modal / toast ---------- */
  function layerRoot() { var r = document.getElementById('layer-root'); if (!r) { r = document.createElement('div'); r.id = 'layer-root'; document.body.appendChild(r); } return r; }
  function modal(o) {
    o = o || {};
    var root = layerRoot(); var prevFocus = document.activeElement;
    var wrap = document.createElement('div'); wrap.className = 'layer';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); if (o.label) wrap.setAttribute('aria-label', o.label);
    wrap.innerHTML = '<div class="layer-backdrop" data-close></div><div class="layer-panel' + (o.full ? ' layer-panel--full' : '') + (o.cls ? ' ' + o.cls : '') + '"><button type="button" class="icon-btn layer-close' + (o.full ? ' icon-btn--dark' : '') + '" data-close aria-label="Close">' + icon('close') + '</button><div class="layer-body"></div></div>';
    var body = wrap.querySelector('.layer-body');
    if (typeof o.content === 'string') body.innerHTML = o.content; else if (o.content) body.appendChild(o.content);
    root.appendChild(wrap);
    document.documentElement.classList.add('has-layer');
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    function close() { document.removeEventListener('keydown', onKey, true); wrap.remove(); if (!root.children.length) document.documentElement.classList.remove('has-layer'); if (prevFocus && prevFocus.focus) try { prevFocus.focus(); } catch (e) { } if (o.onClose) o.onClose(); }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') { var f = wrap.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'); if (!f.length) return; var first = f[0], last = f[f.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } }
      if (o.onKey) o.onKey(e);
    }
    document.addEventListener('keydown', onKey, true);
    wrap.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    var ff = wrap.querySelector(o.focus || '.layer-close'); if (ff) ff.focus();
    return { el: wrap, body: body, close: close };
  }
  var toastTimer;
  function toast(msg, ms) {
    var root = document.getElementById('toast-root'); if (!root) { root = document.createElement('div'); root.id = 'toast-root'; root.setAttribute('aria-live', 'polite'); document.body.appendChild(root); }
    root.innerHTML = '<div class="toast" role="status">' + esc(msg) + '</div>';
    var t = root.firstChild; requestAnimationFrame(function () { t.classList.add('is-in'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { if (t.parentNode) t.remove(); }, 400); }, ms || 3200);
  }

  /* ---------- pointer lighting ---------- */
  function pointerLight(el) {
    var raf = 0, lx = .5, ly = .5;
    function set() { raf = 0; el.style.setProperty('--mx', lx.toFixed(3)); el.style.setProperty('--my', ly.toFixed(3)); }
    el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); lx = (e.clientX - r.left) / r.width; ly = (e.clientY - r.top) / r.height; if (!raf) raf = requestAnimationFrame(set); });
    el.addEventListener('pointerleave', function () { lx = .5; ly = .5; if (!raf) raf = requestAnimationFrame(set); });
    set();
  }

  /* ---------- header menu (phone) ---------- */
  function closeMenu() { var m = document.getElementById('hdr-menu'), b = document.querySelector('[data-menu-toggle]'); if (m) m.classList.remove('is-open'); if (b) { b.setAttribute('aria-expanded', 'false'); b.innerHTML = icon('menu'); } }
  function toggleMenu() { var m = document.getElementById('hdr-menu'), b = document.querySelector('[data-menu-toggle]'); if (!m) return; var open = !m.classList.contains('is-open'); m.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.innerHTML = icon(open ? 'close' : 'menu'); }

  /* ---------- chrome ---------- */
  function renderChrome() {
    document.querySelectorAll('[data-wa-general]').forEach(function (a) { waApply(a, 'Hi AHIHQ Motors, I would like help finding a car.'); });
    document.querySelectorAll('[data-pack-date]').forEach(function (el) { el.textContent = date(NETWORK.packDate, true); });
    document.querySelectorAll('[data-count-cars]').forEach(function (el) { el.textContent = fmt(currentCars().length); });
    syncSaved();
  }

  /* ---------- global delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-save]');
    if (s) { e.preventDefault(); e.stopPropagation(); toggleSaved(s.getAttribute('data-save')); return; }
    var mt = e.target.closest('[data-menu-toggle]'); if (mt) { toggleMenu(); return; }
    var sv = e.target.closest('[data-show-saved]'); if (sv && sv.tagName !== 'A') { e.preventDefault(); go(URLS.saved); return; }
    var sr = e.target.closest('[data-search]'); if (sr && sr.tagName !== 'A') { e.preventDefault(); go(URLS.stock + '?focus=search'); return; }
    /* legacy in-page hash links left in copied markup (#find, #stock?…, #car-REF) → real URLs */
    var a = e.target.closest('a[href^="#"]');
    if (a) { var h = a.getAttribute('href'); if (/^#(find|stock|home|car-)/.test(h)) { e.preventDefault(); go(h); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.getElementById('hdr-menu'); if (!m || !m.classList.contains('is-open')) return;
    closeMenu(); var b = document.querySelector('[data-menu-toggle]'); if (b) try { b.focus(); } catch (x) { }
  });

  /* ---------- boot: inline car first (instant car page), then the feed ---------- */
  function boot() {
    if (A.car) addCars([A.car]);
    if (A.cars) addCars(A.cars);
    renderChrome();
    var feedUrl = (document.querySelector('[data-feed]') || {}).getAttribute ? (document.querySelector('[data-feed]') || document.body).getAttribute('data-feed') : null;
    feedUrl = feedUrl || A.feed || (URLS.stock + '?view=feed');
    var needsFeed = document.querySelector('[data-slot]');
    var ready = function () {
      initAll(); renderAll();
      document.documentElement.setAttribute('data-ready', '1');
      document.dispatchEvent(new CustomEvent('mock:ready', { detail: ctx() }));
    };
    if (!needsFeed) { ready(); return; }
    if (A.car) { ready(); } // render the car page immediately from its inlined record
    loadFeed(feedUrl).then(function (cars) {
      addCars(cars);
      if (A.car) { renderAll(); document.dispatchEvent(new CustomEvent('mock:rerender', { detail: ctx() })); }
      else ready();
    }).catch(function (e) {
      console.error('[ahm] stock feed failed', e);
      if (!A.car) ready();
    });
  }

  /* ---------- public API (same names as the mockup) ---------- */
  var M = {
    get cars() { return currentCars(); }, get all() { return ALL.slice(); }, byRef: byRef, counts: counts, network: NETWORK, published: [],
    get route() { return route; }, review: { device: 'desktop', catalogue: 'live', partnerNote: PARTNER }, get whatsapp() { return WA; },
    reducedMotion: REDUCED, urls: URLS,
    fmt: fmt, km: km, date: date, esc: esc, shortRef: shortRef, icon: icon,
    avail: avail, availHTML: availHTML, specParts: specParts, kmKnown: kmKnown, NON_ROAD: NON_ROAD, networkSummary: networkSummary, netMore: netMore, carHandle: carHandle,
    card: card, img: img, photoOf: photoOf, MARK_TEXT: MARK_TEXT,
    waLink: waLink, waAttrs: waAttrs, waApply: waApply, carMessage: carMessage, carUrl: carUrl, QUESTIONS: QUESTIONS,
    saved: saved, isSaved: isSaved, toggleSaved: toggleSaved, syncSaved: syncSaved,
    NEEDS: NEEDS, need: need, needsOf: needsOf, carsForNeed: carsForNeed, inList: inList,
    marque: marque, marqueSVG: marqueSVG, makes: makes, NO_LOGO: window.MARQUES_NO_LOGO || [],
    view: view, rerender: renderAll, go: go, toUrl: toUrl, stockUrl: stockUrl, parseHash: function () { return route; }, scroller: scroller, scrollTop: scrollTop,
    modal: modal, toast: toast, pointerLight: pointerLight, addCars: addCars
  };
  window.M = M;
  if (document.readyState === 'complete') setTimeout(boot, 0); else document.addEventListener('DOMContentLoaded', boot);
})();
